export default "__VITE_ASSET__YFN1LVEp__"